import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import i18next from 'i18next';
import React, { useEffect } from 'react';
import { GetFishParam } from '../adapters/GetFishParam';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import EditableCustomizableSelect from 'Global/Components/EditableComponents/EditableCustomizableSelect/EditableCustomizableSelect';

const ReceiptMonth = (props) => {
  const month_select_msg = FindLangKey(
    'invoice-receipt-label-select-months'
  );

  const { monthList, name, errors, onChange } = props;

  const dataArray = monthList?.map((month) => ({
    ItemContent: ArabicToPersian(month?.Name),
    ItemValue: month?.Id,
  }));

  console.log('dataArray=>', dataArray);

  return (
    <React.Fragment>
      <div>
        {dataArray ? (
          <EditableCustomizableSelect
            label={month_select_msg}
            isEnglish={i18next.language === 'en'}
            SelectableDataArray={dataArray}
            isSingle={true}
            name={name}
            errors={errors}
            onChange={onChange}
            initialData={dataArray
              ?.filter(
                (item) => item.ItemValue === props?.initial
              )
              .map((el) => ({
                ...el,
                ItemValue: el?.ItemContent,
              }))}
            enableInitialOnchange={true}
          />
        ) : (
          <></>
        )}
      </div>
    </React.Fragment>
  );
};

export default ReceiptMonth;
